import React from 'react';
import Header from '../Header';
import Footer from '../Footer';
import PageHero from './PageHero';

function InnerPageLayout({ tag, title, titleAccent, description, heroChildren, compactHero, children, wide = false }) {
  return (
    <div className="min-h-screen bg-onyx text-mist">
      <Header />
      <PageHero
        tag={tag}
        title={title}
        titleAccent={titleAccent}
        description={description}
        compact={compactHero}
      >
        {heroChildren}
      </PageHero>
      <main className={`relative mx-auto px-6 pb-24 ${wide ? 'max-w-6xl' : 'max-w-4xl'}`}>
        {children}
      </main>
      <Footer />
    </div>
  );
}

export default InnerPageLayout;
